import React, { useEffect, useState } from 'react';
import { api } from '../api/client';

const ROLE_LABELS: Record<string, string> = {
  chairman: 'Удирдах зөвлөлийн дарга',
  board_member: 'Удирдах зөвлөлийн гишүүн',
  audit_chair: 'Хяналтын зөвлөлийн дарга',
  audit_member: 'Хяналтын зөвлөлийн гишүүн',
};

const ROLE_COLORS: Record<string, string> = {
  chairman: '#8b5cf6', board_member: '#3b82f6',
  audit_chair: '#f59e0b', audit_member: '#10b981',
};

export default function BoardPage() {
  const [members, setMembers] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);
  const [showForm, setShowForm] = useState(false);
  const [tab, setTab] = useState<'all' | 'board' | 'audit'>('all');
  const [form, setForm] = useState({
    full_name: '', role: 'board_member', phone: '', email: '',
    unit_number: '', elected_at: '', term_expires_at: '', notes: '',
  });

  const load = () => {
    const q = tab === 'all' ? '' : `?committee=${tab}`;
    api.get(`/admin/board${q}`).then(res => setMembers(res?.items || [])).catch(() => {}).finally(() => setLoading(false));
  };

  useEffect(load, [tab]);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    await api.post('/admin/board', form);
    setShowForm(false);
    setForm({ full_name: '', role: 'board_member', phone: '', email: '', unit_number: '', elected_at: '', term_expires_at: '', notes: '' });
    load();
  };

  const handleDelete = async (id: string) => {
    if (!window.confirm('Устгах уу?')) return;
    await api.delete(`/admin/board/${id}`);
    load();
  };

  const boardMembers = members.filter(m => ['chairman', 'board_member'].includes(m.role));
  const auditMembers = members.filter(m => ['audit_chair', 'audit_member'].includes(m.role));

  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 24 }}>
        <h2 style={{ fontFamily: "'Inter'", fontWeight: 700, color: '#1c2b22' }}>Удирдах & Хяналтын зөвлөл</h2>
        <button onClick={() => setShowForm(!showForm)} style={btnPrimary}>
          {showForm ? 'Болих' : '+ Гишүүн нэмэх'}
        </button>
      </div>

      <div style={{ display: 'flex', gap: 8, marginBottom: 16 }}>
        {(['all', 'board', 'audit'] as const).map(t => (
          <button key={t} onClick={() => setTab(t)} style={{
            padding: '6px 14px', border: 'none', borderRadius: 6, cursor: 'pointer',
            background: tab === t ? '#236844' : '#e8e5dc', color: tab === t ? '#fff' : '#2a3b32',
            fontSize: 13, fontWeight: 500,
          }}>
            {t === 'all' ? 'Бүгд' : t === 'board' ? 'Удирдах зөвлөл' : 'Хяналтын зөвлөл'}
          </button>
        ))}
      </div>

      {showForm && (
        <div style={card}>
          <form onSubmit={handleSubmit}>
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: 16, marginBottom: 16 }}>
              <div>
                <label style={labelStyle}>Бүтэн нэр</label>
                <input value={form.full_name} onChange={e => setForm({ ...form, full_name: e.target.value })} style={inputStyle} required />
              </div>
              <div>
                <label style={labelStyle}>Албан тушаал</label>
                <select value={form.role} onChange={e => setForm({ ...form, role: e.target.value })} style={inputStyle}>
                  <option value="chairman">Удирдах зөвлөлийн дарга</option>
                  <option value="board_member">Удирдах зөвлөлийн гишүүн</option>
                  <option value="audit_chair">Хяналтын зөвлөлийн дарга</option>
                  <option value="audit_member">Хяналтын зөвлөлийн гишүүн</option>
                </select>
              </div>
              <div>
                <label style={labelStyle}>Орон сууц</label>
                <input value={form.unit_number} onChange={e => setForm({ ...form, unit_number: e.target.value })} style={inputStyle} placeholder="1А-101" />
              </div>
              <div>
                <label style={labelStyle}>Утас</label>
                <input value={form.phone} onChange={e => setForm({ ...form, phone: e.target.value })} style={inputStyle} />
              </div>
              <div>
                <label style={labelStyle}>И-мэйл</label>
                <input value={form.email} onChange={e => setForm({ ...form, email: e.target.value })} style={inputStyle} />
              </div>
              <div>
                <label style={labelStyle}>Сонгогдсон огноо</label>
                <input type="date" value={form.elected_at} onChange={e => setForm({ ...form, elected_at: e.target.value })} style={inputStyle} />
              </div>
              <div>
                <label style={labelStyle}>Бүрэн эрх дуусах</label>
                <input type="date" value={form.term_expires_at} onChange={e => setForm({ ...form, term_expires_at: e.target.value })} style={inputStyle} />
              </div>
              <div style={{ gridColumn: '2 / -1' }}>
                <label style={labelStyle}>Тэмдэглэл</label>
                <input value={form.notes} onChange={e => setForm({ ...form, notes: e.target.value })} style={inputStyle} />
              </div>
            </div>
            <button type="submit" style={btnPrimary}>Нэмэх</button>
          </form>
        </div>
      )}

      {loading ? <p>Уншиж байна...</p> : (
        <div style={{ display: 'grid', gap: 24 }}>
          {(tab === 'all' || tab === 'board') && boardMembers.length > 0 && (
            <div style={card}>
              <h3 style={{ fontFamily: "'Inter'", fontWeight: 600, marginBottom: 16, color: '#236844' }}>Удирдах зөвлөл ({boardMembers.length})</h3>
              {_renderTable(boardMembers, handleDelete)}
            </div>
          )}
          {(tab === 'all' || tab === 'audit') && auditMembers.length > 0 && (
            <div style={card}>
              <h3 style={{ fontFamily: "'Inter'", fontWeight: 600, marginBottom: 16, color: '#f59e0b' }}>Хяналтын зөвлөл ({auditMembers.length})</h3>
              {_renderTable(auditMembers, handleDelete)}
            </div>
          )}
          {members.length === 0 && <p style={{ color: '#64748b' }}>Гишүүн бүртгэгдээгүй байна</p>}
        </div>
      )}
    </div>
  );
}

function _renderTable(members: any[], onDelete: (id: string) => void) {
  return (
    <table style={{ width: '100%', borderCollapse: 'collapse' }}>
      <thead>
        <tr style={{ borderBottom: '2px solid #e8e5dc', textAlign: 'left' }}>
          <th style={th}>Нэр</th>
          <th style={th}>Албан тушаал</th>
          <th style={th}>Орон сууц</th>
          <th style={th}>Утас</th>
          <th style={th}>Сонгогдсон</th>
          <th style={th}>Дуусах</th>
          <th style={th}>Үйлдэл</th>
        </tr>
      </thead>
      <tbody>
        {members.map((m: any) => (
          <tr key={m.id} style={{ borderBottom: '1px solid #e8e5dc' }}>
            <td style={td}><strong>{m.full_name}</strong></td>
            <td style={td}>
              <span style={{
                background: (ROLE_COLORS[m.role] || '#6b7280') + '20',
                color: ROLE_COLORS[m.role] || '#6b7280',
                padding: '2px 8px', borderRadius: 4, fontSize: 12, fontWeight: 600,
              }}>{ROLE_LABELS[m.role] || m.role}</span>
            </td>
            <td style={td}>{m.unit_number || '-'}</td>
            <td style={td}>{m.phone || '-'}</td>
            <td style={td}>{m.elected_at || '-'}</td>
            <td style={td}>{m.term_expires_at || '-'}</td>
            <td style={td}>
              <button onClick={() => onDelete(m.id)} style={{
                background: '#fee2e2', color: '#dc2626', border: 'none',
                padding: '4px 10px', borderRadius: 4, cursor: 'pointer', fontSize: 12,
              }}>Устгах</button>
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  );
}

const btnPrimary: React.CSSProperties = {
  background: 'linear-gradient(180deg, #2f7d52, #236844)', color: '#fff', border: 'none', padding: '8px 20px',
  borderRadius: 10, cursor: 'pointer', fontWeight: 600, fontSize: 14, fontFamily: "'Inter'",
};
const card: React.CSSProperties = {
  background: '#fff', borderRadius: 12, padding: 20, boxShadow: '0 1px 3px rgba(0,0,0,0.06)',
};
const labelStyle: React.CSSProperties = { display: 'block', marginBottom: 4, fontSize: 13, color: '#2a3b32', fontWeight: 500 };
const inputStyle: React.CSSProperties = {
  width: '100%', padding: '8px 12px', border: '1.5px solid #dcdacf', borderRadius: 10, fontSize: 14, boxSizing: 'border-box', background: '#fbfaf6',
};
const th: React.CSSProperties = { padding: '10px 12px', fontSize: 13, color: '#5f6f66', fontWeight: 600 };
const td: React.CSSProperties = { padding: '10px 12px', fontSize: 14, color: '#1c2b22' };
